module.exports = __webpack_public_path__ + "static/media/sonicboom_arena_map@3x.aa51a1b0.png";